// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'font-awesome/css/font-awesome.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import BaiduMap from 'vue-baidu-map'
import store from './vuex/store';
import vant from 'vant'
import 'vant/lib/index.css'
Vue.use(vant)
import vueEsign from 'vue-esign';
Vue.use(vueEsign)
import axios from 'axios';
Vue.prototype.$axios = axios;
import qs from 'qs'
Vue.prototype.qs = qs;
axios.defaults.withCredentials = true;
axios.defaults.headers = {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}

axios.interceptors.request.use(
    config => {
        if(config.url.indexOf('/zny/login/wechatPcSubmit.jhtml') !== -1 ||config.url.indexOf('/zny/register/sendWeLogincode.jhtml') !== -1 || config.url.indexOf('/zny/login/mobile/sendcode.jhtml') !== -1 || config.url.indexOf('/zny/login/registerSubmit.jhtml') !== -1 || config.url.indexOf('/zny/login/forgetPassword.jhtml') !== -1 || config.url.indexOf('/zny/login/mobilesubmit.jhtml') !== -1  || config.url.indexOf('/connect/oauth2/authorize') !== -1|| config.url.indexOf('/posts/') !== -1 || config.url.indexOf('/cms/file/upload.do') !== -1|| config.url.indexOf('/zny/mobile/enterpriseEvaluation/createSmallBusinessEvaluation') !== -1){
            return config
        }
        else{
            config.headers['jwt'] = `${store.state.jwt}`
                  // config.headers['jwt']='eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MTk1ODg2MDcwOCwidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi5p6X6JC9XCIsXCJoZWFkUGljXCI6XCJodHRwOi8vd3d3LjE3Nzhody5jb20vY21zL2ltYWdlLzIwMjAvMDgvMTIvYTc5M2E3NzItZTc0Mi00ZDcyLThkZjMtMzI3YzJjYmEyNjRiLkpQR1wiLFwiaWRcIjpcIjg5NzhcIn0iLCJqdGkiOiJqd3QiLCJpYXQiOjE1OTg4NjA3MDh9.sDKBlx_IWcIF77L-ZL2JRjGRyxMOOF81LfRzqFXn1Ic'
      // config.headers['jwt']='eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MTk1MzMzMjIyMCwidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi6bqm5Y2O5pmuXCIsXCJoZWFkUGljXCI6XCJodHRwOi8vdGhpcmR3eC5xbG9nby5jbi9tbW9wZW4vdmlfMzIvUTBqNFR3R1RmVEt6SXZ5QjZpYVVCZGc0WGp5aHo4UWpKZXhSc2VUbmMyZmJPc05XN0ZveEpUQzhwdHBVTXVUeVZhMjNpYndtZHBVNFBOeE4weGtoT0lOQS8xMzJcIixcImlkXCI6XCI4OTY2XCJ9IiwianRpIjoiand0IiwiaWF0IjoxNTkzMzMyMjIwfQ.QVvPQSYMqTtaTVf1wWAQLZVs9hhb8tXOczkwgCI-e1U'
      //  config.headers['jwt']='eyJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJEU1NGQVdEV0FEQVMuLi4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi6ZmI5YawXCIsXCJoZWFkUGljXCI6XCJodHRwczovL3RoaXJkd3gucWxvZ28uY24vbW1vcGVuL3ZpXzMyL0Z4TWlidFFGbWRjRU5hdXVJSVpXbXpFMEh2WDk0Um9nVkZVZGxzd1lJT2hVWjRRc1NGaWJuRjhvOEZpY2c2eDBqZUVMaWFpY1NwMnZNVzhOd3BwSG1pYUVib3RRLzEzMlwiLFwiaWRcIjpcIjk5MzAyXCJ9IiwidXNlcl9uYW1lIjoiYWRtaW4iLCJuaWNrX25hbWUiOiJEQVNEQTEyMSIsImV4cCI6MjAzODU0Mjc5OSwiaWF0IjoxNjc4NTQyNzk5LCJqdGkiOiJqd3QifQ.ZwqMbY8XUJH5q-jDnGvESVIp0-H5Yx_5p1i_MG91kFw'
            // config.headers['jwt'] = `eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MjAyMzY2Nzc4OCwidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi5amJ5aa5XCIsXCJoZWFkUGljXCI6XCJodHRwczovL3RoaXJkd3gucWxvZ28uY24vbW1vcGVuL3ZpXzMyL1EwajRUd0dUZlRKTE9ad2xDUXVZcHhlb0lEWnlxQWc3ZmRCTzF4bXdFV25QS3YyMkdjQ21MQTBCSmJOYlJYdVYzSHQyTUxpY3hCWjA0bHRyS2ZwYllQZy8xMzJcIixcImlkXCI6XCI5MDk0XCJ9IiwianRpIjoiand0IiwiaWF0IjoxNjYzNjY3Nzg4fQ.kzwRKzjHKSiGAnreIXQfwY1u2cnDwq9oSIfoNisu7VU`
            // config.headers['jwt'] = `eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MjAyMzY3NzI0MywidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi5b-D55eVMjMxXCIsXCJoZWFkUGljXCI6XCJodHRwczovL3RoaXJkd3gucWxvZ28uY24vbW1vcGVuL3ZpXzMyL0RZQUlPZ3E4M2VwTWpsd0t1OEV3ZEN0WmljaEpHTTRPTzFJOHR4SmZTejFsZjJDUXJDbFZscEdKM004SURZWVJ0cWxKb3ZDNE5QN2liWW5VZTNBV3dnU1EvMTMyXCIsXCJpZFwiOlwiOTg3NDJcIn0iLCJqdGkiOiJqd3QiLCJpYXQiOjE2NjM2NzcyNDN9.2f904wgsT6-2U1XdCkzckS1_t0GOCDF8SmEsMIl-388`
            // config.headers['jwt']='eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MTk1MzMzMjIyMCwidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi6bqm5Y2O5pmuXCIsXCJoZWFkUGljXCI6XCJodHRwOi8vdGhpcmR3eC5xbG9nby5jbi9tbW9wZW4vdmlfMzIvUTBqNFR3R1RmVEt6SXZ5QjZpYVVCZGc0WGp5aHo4UWpKZXhSc2VUbmMyZmJPc05XN0ZveEpUQzhwdHBVTXVUeVZhMjNpYndtZHBVNFBOeE4weGtoT0lOQS8xMzJcIixcImlkXCI6XCI4OTY2XCJ9IiwianRpIjoiand0IiwiaWF0IjoxNTkzMzMyMjIwfQ.QVvPQSYMqTtaTVf1wWAQLZVs9hhb8tXOczkwgCI-e1U'
              // config.headers['jwt'] =  'eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MjAzNzMxMzU3NiwidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwi54SVd2hpdGVfXuOAgVwiLFwiaGVhZFBpY1wiOlwiaHR0cHM6Ly90aGlyZHd4LnFsb2dvLmNuL21tb3Blbi92aV8zMi9EWUFJT2dxODNlcE1qbHdLdThFd2RDdFppY2hKR000T08xSTh0eEpmU3oxbGYyQ1FyQ2xWbHBHSjNNOElEWVlSdHFsSm92QzROUDdpYlluVWUzQVd3Z1NRLzEzMlwiLFwiaWRcIjpcIjk4NzQyXCJ9IiwianRpIjoiand0IiwiaWF0IjoxNjc3MzEzNTc2fQ.sPE7OheyqsgZkzx9xZ-CQQJGsXNTrVGCz2OkSlp00XE'
              // config.headers['jwt'] =  'eyJhbGciOiJIUzI1NiJ9.eyJuaWNrX25hbWUiOiJEQVNEQTEyMSIsInVpZCI6IkRTU0ZBV0RXQURBUy4uLiIsImV4cCI6MjA3OTQyMDIzNCwidXNlcl9uYW1lIjoiYWRtaW4iLCJzdWIiOiJ7XCJ1c2VybmFtZVwiOlwiJiMxMjg1MjI7XCIsXCJoZWFkUGljXCI6XCJodHRwczovL3RoaXJkd3gucWxvZ28uY24vbW1vcGVuL3ZpXzMyL0RZQUlPZ3E4M2VwTWpsd0t1OEV3ZEN0WmljaEpHTTRPTzFJOHR4SmZTejFsZjJDUXJDbFZscEdKM004SURZWVJ0cWxKb3ZDNE5QN2liWW5VZTNBV3dnU1EvMTMyXCIsXCJpZFwiOlwiOTg3NDJcIn0iLCJqdGkiOiJqd3QiLCJpYXQiOjE3MTk0MjAyMzR9.oM8H3vWE1ws8dtdrqUqsGbfix3KNvCmPh8fLu311MBM'
            return config
        }
    },function(error){
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(function(response) {
    // 对响应数据做处理
    if (response.data.code && response.data.code == 401) {
        //store.state.memberInfo = ''
      setTimeout(function () {
        router.push('/login');
      },1500)

    }
    return response;

}, function(error) {
    // 对权限过期的，跳转登录页，重新登录获取权限。
    if (error.response.code && error.response.code === 401) {
        //store.state.memberInfo = ''
      setTimeout(function () {
        router.push('/login');
      },1500)

    }
    return Promise.reject(error);
});

axios.defaults.baseURL = process.env.API_ROOT;
//axios.defaults.baseURL = 'https://www.zhengyirc.com/zny';

axios.defaults.timeout = 35000;

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'DvY2lKKBaNthnAtgRnHo1Qv8WCQGPAgI'
})
// require styles
// import 'swiper/css/swiper.css'
import '../static/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js